import { lazy } from 'react';
import { Outlet } from 'react-router-dom';
// layouts
import { CameraToanCanh } from 'src/sections/losam/view/CameraToanCanh';
import path from 'path';
import MainLayout from 'src/layouts/main';
import SimpleLayout from 'src/layouts/simple';



export const cameraRoutes = [
  {
    path: '/camera', 
    element: (
      <MainLayout>
        <Outlet />
      </MainLayout>
    ),
    children: [
      { path: 'camera-toan-canh', element: <CameraToanCanh /> },
    ],
  },
];
